import React, { useState } from 'react';
import { Modal, Box, SpaceBetween } from '@cloudscape-design/components';
import { TreeSelect } from 'antd';
import Button from '../Button';
import { Workflow } from "@amzn/finspace-service-typescript-client";

interface RunWorkflowModalProps {
  visible: boolean;
  workflow: Workflow | null;
  loading?: boolean;
  onRun: (period: string) => void;
  onCancel: () => void;
}

const periodTreeData = [
  {
    title: '2025',
    value: '2025',
    key: '2025',
    children: [
      {
        title: 'Q3 2025',
        value: 'q3-2025',
        key: 'q3-2025',
        children: [
          { title: 'Aug 2025', value: 'aug-2025', key: 'aug-2025' },
          { title: 'Jul 2025', value: 'jul-2025', key: 'jul-2025' }
        ]
      },
      {
        title: 'Q2 2025',
        value: 'q2-2025',
        key: 'q2-2025',
        children: [
          { title: 'Jun 2025', value: 'jun-2025', key: 'jun-2025' },
          { title: 'May 2025', value: 'may-2025', key: 'may-2025' },
          { title: 'Apr 2025', value: 'apr-2025', key: 'apr-2025' }
        ]
      },
      {
        title: 'Q1 2025',
        value: 'q1-2025',
        key: 'q1-2025',
        children: [
          { title: 'Mar 2025', value: 'mar-2025', key: 'mar-2025' },
          { title: 'Feb 2025', value: 'feb-2025', key: 'feb-2025' },
          { title: 'Jan 2025', value: 'jan-2025', key: 'jan-2025' }
        ]
      }
    ]
  },
  {
    title: '2024',
    value: '2024',
    key: '2024',
    children: [
      {
        title: 'Q4 2024',
        value: 'q4-2024',
        key: 'q4-2024',
        children: [
          { title: 'Dec 2024', value: 'dec-2024', key: 'dec-2024' },
          { title: 'Nov 2024', value: 'nov-2024', key: 'nov-2024' },
          { title: 'Oct 2024', value: 'oct-2024', key: 'oct-2024' }
        ]
      },
      {
        title: 'Q3 2024',
        value: 'q3-2024',
        key: 'q3-2024',
        children: [
          { title: 'Sep 2024', value: 'sep-2024', key: 'sep-2024' },
          { title: 'Aug 2024', value: 'aug-2024', key: 'aug-2024' },
          { title: 'Jul 2024', value: 'jul-2024', key: 'jul-2024' }
        ]
      },
      {
        title: 'Q2 2024',
        value: 'q2-2024',
        key: 'q2-2024',
        children: [
          { title: 'Jun 2024', value: 'jun-2024', key: 'jun-2024' },
          { title: 'May 2024', value: 'may-2024', key: 'may-2024' },
          { title: 'Apr 2024', value: 'apr-2024', key: 'apr-2024' }
        ]
      },
      {
        title: 'Q1 2024',
        value: 'q1-2024',
        key: 'q1-2024',
        children: [
          { title: 'Mar 2024', value: 'mar-2024', key: 'mar-2024' },
          { title: 'Feb 2024', value: 'feb-2024', key: 'feb-2024' },
          { title: 'Jan 2024', value: 'jan-2024', key: 'jan-2024' }
        ]
      }
    ]
  },
  {
    title: '2023',
    value: '2023',
    key: '2023',
    children: [
      {
        title: 'Q4 2023',
        value: 'q4-2023',
        key: 'q4-2023',
        children: [
          { title: 'Dec 2023', value: 'dec-2023', key: 'dec-2023' },
          { title: 'Nov 2023', value: 'nov-2023', key: 'nov-2023' },
          { title: 'Oct 2023', value: 'oct-2023', key: 'oct-2023' }
        ]
      },
      {
        title: 'Q3 2023',
        value: 'q3-2023',
        key: 'q3-2023',
        children: [
          { title: 'Sep 2023', value: 'sep-2023', key: 'sep-2023' },
          { title: 'Aug 2023', value: 'aug-2023', key: 'aug-2023' },
          { title: 'Jul 2023', value: 'jul-2023', key: 'jul-2023' }
        ]
      },
      {
        title: 'Q2 2023',
        value: 'q2-2023',
        key: 'q2-2023',
        children: [
          { title: 'Jun 2023', value: 'jun-2023', key: 'jun-2023' },
          { title: 'May 2023', value: 'may-2023', key: 'may-2023' },
          { title: 'Apr 2023', value: 'apr-2023', key: 'apr-2023' }
        ]
      },
      {
        title: 'Q1 2023',
        value: 'q1-2023',
        key: 'q1-2023',
        children: [
          { title: 'Mar 2023', value: 'mar-2023', key: 'mar-2023' },
          { title: 'Feb 2023', value: 'feb-2023', key: 'feb-2023' },
          { title: 'Jan 2023', value: 'jan-2023', key: 'jan-2023' }
        ]
      }
    ]
  }
];

export const RunWorkflowModal: React.FC<RunWorkflowModalProps> = ({
  visible,
  workflow,
  loading = false,
  onRun,
  onCancel,
}) => {
  const [selectedPeriod, setSelectedPeriod] = useState<string>('aug-2025');

  const handleRun = () => {
    onRun(selectedPeriod);
  };

  return (
    <Modal
      visible={visible}
      onDismiss={onCancel}
      header="Run MFR Report/Analysis"
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="secondary" onClick={onCancel} disabled={loading}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleRun} loading={loading}>
              Run Report
            </Button>
          </SpaceBetween>
        </Box>
      }
    >
      <SpaceBetween direction="vertical" size="m">
        <Box variant="p">
          Select the reporting period for your MFR analysis. The report will be generated using your current workflow configuration for the selected period.
        </Box>
        
        <Box>
          <Box variant="strong">Running: {workflow?.name}</Box>
        </Box>

        <Box>
          <Box variant="strong" padding={{ bottom: 'xs' }}>Select Period</Box>
          <TreeSelect
            value={selectedPeriod}
            onChange={setSelectedPeriod}
            treeData={periodTreeData}
            placeholder="Select period..."
            treeDefaultExpandAll={false}
            showSearch
            allowClear
            style={{ width: '100%' }}
            getPopupContainer={(trigger) => trigger.parentElement || document.body}
          />
        </Box>

        <Box variant="p" color="text-body-secondary">
          The report will be generated for the selected period with the current configuration.
        </Box>
      </SpaceBetween>
    </Modal>
  );
};
